import React from 'react';

interface ThumbsDownIconProps {
  className?: string;
  stroke?: string;
}

export default function ThumbsDownIcon({ className, stroke = 'currentColor' }: ThumbsDownIconProps) {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M3.75 6.125H9.375V18.3125H3.75C3.50136 18.3125 3.2629 18.2137 3.08709 18.0379C2.91127 17.8621 2.8125 17.6236 2.8125 17.375V7.0625C2.8125 6.81386 2.91127 6.5754 3.08709 6.39959C3.2629 6.22377 3.50136 6.125 3.75 6.125V6.125Z"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.375 18.3125L14.0625 27.6875C15.0571 27.6875 16.0109 27.2924 16.7141 26.5891C17.4174 25.8859 17.8125 24.9321 17.8125 23.9375V21.125H25.0664C25.3323 21.1257 25.5952 21.0694 25.8375 20.96C26.0798 20.8507 26.296 20.6907 26.4713 20.4909C26.6467 20.2911 26.7773 20.0561 26.8544 19.8016C26.9314 19.5472 26.9531 19.2792 26.918 19.0156L25.5117 7.76562C25.4548 7.31401 25.2356 6.8985 24.8949 6.59663C24.5542 6.29475 24.1153 6.12712 23.6602 6.125H9.375"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
